if (!customElements.get('product-bundle-item')) {
  class ProductBundleItem extends HTMLElement {
    openers = this.querySelectorAll('.js-opener');
    dialog = this.querySelector('.product-bundle-item__dialog');
    selectedOptionsContainer = this.querySelector('.js-selected-options');
    selectedVariantIds = [];
    includedAttr = 'data-included';

    constructor() {
      super();
    }

    connectedCallback() {
      this.titles = {};
      this.isIncluded = this.hasAttribute(this.includedAttr);
      this.attachEvents();
    }

    /**
     * Attaches the necessary event listeners
     */
    attachEvents() {
      for (const opener of this.openers) {
        opener.addEventListener('click', this.toggleDialog.bind(this)); 
      }

      this.querySelector('.js-select-option').addEventListener('click', this.onOptionSelected.bind(this));
      this.addEventListener('click', event => {
        if (event.target.closest('.js-remove-selected-bundle-product')) {
          this.onRemoveSelectedBundleProductClick(event);
        }
      });
    }

    /**
     * Toggles the dialog open and closed
     */
    toggleDialog() {
      this.dialog.open ? this.dialog.close() : this.dialog.showModal();
    }

    /**
     * Adds the selected option(s) to the selected options container
     */
    onOptionSelected() {
      this.selectedVariantIds = [];
      this.selectedTitles = {};
      
      this.clearSelectedOptions();
      this.querySelectorAll('bundle-product.is-selected').forEach(product => {
        const selectedProductMarkup = product.querySelector('template').innerHTML;
        this.selectedOptionsContainer.insertAdjacentHTML('beforeend', selectedProductMarkup);
        this.addVariant(product.dataset.variantId);
        this.addVariantTitle(product.dataset.variantId, product.dataset.title);
      });

      this.renderBundlePrice();
      this.updateVariantIdInputs();
      this.handleButtonState();
      this.dialog.close();
    }

    /**
     * Clears the selected options container
     */
    clearSelectedOptions() {
      this.selectedOptionsContainer.innerHTML = '';
    }

    /**
     * Adds a variant to the bundle.
     * @param {String} variantId - The variant ID to add.
     */
    addVariant(variantId) {
      this.selectedVariantIds.push(variantId);
    }

    addVariantTitle(variantId, title) {
      this.titles[variantId] = title;
    }

    /**
     * Removes a variant from the bundle.
     * @param {String} variantId - The variant ID to remove.
     */
    removeVariant(variantId) {
      this.selectedVariantIds = this.selectedVariantIds.filter(id => id !== variantId);
      delete this.titles[variantId];
      this.dialog.querySelector(`bundle-product[data-variant-id="${variantId}"]`).classList.remove('is-selected');
    }

    /**
     * Handles the click event for removing a selected bundle product.
     * @param {Event} event 
     */
    onRemoveSelectedBundleProductClick(event) {
      const selectedBundleProduct = event.target.closest('.selected-bundle-product');
      this.removeVariant(selectedBundleProduct.dataset.variantId);
      selectedBundleProduct.remove();

      const bundleProduct = this.querySelector(`.bundle-product[data-variant-id="${selectedBundleProduct.dataset.variantId}"]`);
      bundleProduct.classList.remove('is-selected');

      this.renderBundlePrice();
      this.updateVariantIdInputs();
      this.handleButtonState();
    }

    /**
     * Renders the total price of the bundle.
     */
    renderBundlePrice() {
      const priceContainer = document.querySelector('.js-bundle-price');
      const priceSubtotalContainer = document.querySelector('.js-bundle-price-subtotal');

      if (!priceContainer) return;

      const prices = [];
      let totalPrice = 0;

      document.querySelectorAll('.product-bundle-item').forEach(bundleItem => {
        const isIncluded = bundleItem.hasAttribute(this.includedAttr);
        const title = bundleItem.dataset.title;
        const selectedBundleProducts = bundleItem.querySelectorAll('.selected-bundle-product');
        
        if (!title || !selectedBundleProducts.length) return;

        const price = Array.from(selectedBundleProducts).map(product => product.dataset.price).reduce((total, price) => {
          return Number(total) + Number(price);
        });

        prices.push(`<div class="bundle-price__row${isIncluded ? ' bundle-price__row--strikethrough' : ''}"><span>${title}:</span> <span>${Shopify.formatMoney(price, window.money_format)}</span></div>`);

        if(!isIncluded) {
          totalPrice += Number(price);
        }
      });

      priceContainer.innerHTML = prices.join('');
      
      if(!priceSubtotalContainer) return;
      priceSubtotalContainer.innerHTML = Shopify.formatMoney(totalPrice, window.money_format);
    }

    /**
     * Renders the hidden inputs for the selected variant IDs.
     */
    updateVariantIdInputs() {
      const variantIdsContainer = document.querySelector('.js-bundle-products-ids');

      if (!variantIdsContainer) return;

      const selectedVariantIds = [];
      const propertyData = [];

      document.querySelectorAll('.product-bundle-item').forEach(bundleItem => {
        const isIncluded = bundleItem.hasAttribute(this.includedAttr);

        bundleItem.selectedVariantIds.forEach(variantId => {
          if(!isIncluded) {
            selectedVariantIds.push(variantId);
          } else {
            propertyData.push(bundleItem.titles[variantId]);
          }
        });
      });

      variantIdsContainer.innerHTML = '';
      this.createIdInputs(selectedVariantIds, variantIdsContainer);
      this.createPropertyInputs(propertyData, variantIdsContainer);
    }

    createPropertyInputs(propertyData, variantIdsContainer) {
      propertyData.forEach((title, index) => {
        const input = document.createElement('input');
        input.setAttribute('type', 'text');
        input.setAttribute('name', `items[0][properties][Bundle-${index + 1}]`);
        input.setAttribute('value', title);
        input.classList.add('visually-hidden')
        variantIdsContainer.appendChild(input);
      });
    }

    createIdInputs(selectedVariantIds, variantIdsContainer) {
      selectedVariantIds.forEach((variantId, index) => {
        const input = document.createElement('input');
        input.setAttribute('type', 'hidden');
        input.setAttribute('name', `items[${index}]id`);
        input.setAttribute('value', variantId);
        variantIdsContainer.appendChild(input);
      });
    }

    handleButtonState() {
      const allRequiredProducts = document.querySelectorAll('.product-bundle-item[data-required]');
      const areAllRequiredProductsSelected = 
        !allRequiredProducts.length || Array.from(allRequiredProducts).every(bundleItem => bundleItem.querySelector('.selected-bundle-product'));

      const button = document.querySelector('.js-bundle-submit');
      button.disabled = !areAllRequiredProductsSelected;
    }
  }
  customElements.define('product-bundle-item', ProductBundleItem);
}